export default __webpack_public_path__ + "static/media/SkillTonic.5131cd04238aeeca254e00f7bd6fea54.webp";